import { DataGridColSettings } from '@/components/DataGrid/utils';
import { IVisitNote } from '@/pages/Tools/BuildingInspection/Models';

export const visitNotesFormFields = [
  {
    name: 'note',
    label: 'Site visit note',
    type: 'textarea',
    multiline: true,
    placehoder: '/',
    rows: 3,
    grid: {
      sm: 12,
      xs: 12,
    },
  },
  {
    name: 'photoUrl',
    label: 'Upload photo',
    type: 'file',

    grid: {
      sm: 12,
      xs: 12,
    },
  },
];
export const visitNotesList: IVisitNote[] = [
  {
    _id: 'vn1',
    inspection_id: 'ins-001-1',
    note: 'Inspected kitchen area, noted minor ceiling leak near vent.',
    photoUrl: '/photos/ceiling_leak.jpg',
  },
  {
    _id: 'vn2',
    inspection_id: 'insp_101',
    note: 'Fire alarm panel tested, functioning as expected.',
    photoUrl: '/photos/alarm_panel.jpg',
  },
  {
    _id: 'vn3',
    inspection_id: 'insp_102',
    note: 'Exterior emergency lights replaced; working correctly.',
    photoUrl: '/photos/exterior_lights.jpg',
  },
  {
    _id: 'vn4',
    inspection_id: 'insp_103',
    note: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    photoUrl: '/photos/basement_wall.jpg',
  },
];

export const visitNotesDataGridCols: DataGridColSettings[] = [
  {
    field: 'note',
    headerName: 'Notes',
    visible: true,
  },
  {
    field: 'photoUrl',
    headerName: 'Photo',
    width: 300,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];
export const visitNotesDataGridColsReduced: DataGridColSettings[] = [
  {
    field: 'note',
    headerName: 'Notes',
    visible: true,
  },
  {
    field: 'photoUrl',
    headerName: 'Photo',
    width: 300,
    visible: true,
  },
];
